export const schoolProjects = [
  {
    title: "Bohnanza",
    features: [
      "Modified 2-Player Ruleset with a shared Offer Area (no trading between players) and both players’ hands visible for added strategy.",
      "Streamlined GUI Design using counters to represent piles of identical bean cards (saves space while keeping counts accurate).",
      "Interactive Player Areas with bean fields, coin counters, and purchaseable third field, plus deck/discard displays and turn indicators.",
      "Comprehensive Deck System with shuffling, re-shuffling from discard, card drawing, and tracking of deck/discard sizes.",
      "Smart Computer AI Opponent with scalable difficulty: Basic AI: plants matching beans, harvests least profitable fields. Intermediate AI: evaluates hand/offer synergy and opponent’s visible cards for better decisions."
    ],
    techStack: ["Java", "Java Swing", "JavaFX", "OOP"],
    images: [
      "/school_project_images/bohnanza1.png",
      "/school_project_images/bohnanza2.png",
      "/school_project_images/bohnanza3.png"
    ],
    links: {
      github: "https://github.com/Anahat07/Bohnanza",
    }
  },
  {
    title: "PacMan Recreated",
    features: ["My PacMan was developed using Java, enhancing the classic Pac-Man game with additional features and power-ups.",
      "Java's Swing and JavaFX libraries were utilized to create the game's graphical interface and handle user interactions.",
      "The game includes custom implementations for new power-ups and gameplay mechanics, extending the original game's functionality."],
    techStack: ["Java", "Java Swing", "JavaFX, OOP"],
    images: ["/school_project_images/pacman-1.png",
      "/school_project_images/pacman-2.png",
      "/school_project_images/pacman-3.png",
    ],
    links: {
      github: "https://github.com/Anahat07/PacMan"
    }
  },
  {
    title: "PitchPerfect",
    features: [
      "PDF File Upload & Parsing: Users can upload pitch documents (PDF) for automated content extraction and evaluation.",
      "SWOT-Based Assessment: Applies a structured framework to identify strengths, weaknesses, opportunities, and threats in the pitch.",
      "Rule-Based “AI-Like” Scoring: Uses heuristic checks (clarity, structure, persuasiveness, keyword frequency) to simulate intelligent analysis.",
      "Automated Feedback Reports: Generates tailored insights highlighting what works well and what needs improvement.",
      "Java GUI Interface: Intuitive interface for uploading PDFs, running analysis, and viewing feedback results.",
      "Extensible Framework: Modular design enables adding new evaluation categories or integrating future AI/ML models.",
      "Practical Use Case: Helps students, entrepreneurs, and professionals refine pitch decks through structured, automated analysis."
    ],
    techStack: ["Java", "Java Swing", "OOP"],
    images: ["/school_project_images/pitchPerfect1.png",
      "/school_project_images/pitchPerfect2.png",
      "/school_project_images/pitchPerfect3.png",
      "/school_project_images/pitchPerfect4.png",
      "/school_project_images/pitchPerfect5.png",
      "/school_project_images/pitchPerfect6.png"
    ],
    links: {
      github: "https://github.com/Anahat07/PitchPerfect"
    }
  },
  {
    title: "ArrayAid",
    features: ["ArrayMaster CAI was developed using Java to create an interactive computer-assisted instruction tool focused on teaching arrays.",
      "The project integrates various Java libraries and frameworks to deliver interactive lessons, dynamic games, and quizzes.",
      "Java's Object-Oriented Programming principles were used to design a modular and scalable application, while Swing or JavaFX provided the graphical user interface for engaging interactions."],
    techStack: ["Java", "Java Swing", "JavaFX", "OOP"],
    images: ["/school_project_images/arrayaid-1.png",
      "/school_project_images/arrayaid-2.png",
      "/school_project_images/arrayaid-3.png",
      "/school_project_images/arrayaid-4.png",
    ],
    links: {
      github: "https://github.com/Anahat07/ArrayAid"
    }
  },
  {
    title: "Combat Hate Crimes Canada",
    features: ["Educational Resources: Provides detailed articles and guides on hate crimes, legal definitions, and reporting procedures.",
      "Legal Support Section: Outlines relevant Canadian laws and offers links to official resources for reporting hate crimes and seeking legal assistance.",
      "Contact Us: Provides a form or email address for users to get in touch with the website administrators for questions or support."],
    techStack: ["HTML", "CSS", "JavaScript"],
    images: ["/school_project_images/hate-crimes-1.png",
      "/school_project_images/hate-crimes-2.png",
      "/school_project_images/hate-crimes-3.png",
    ],
    links: {
      github: "https://github.com/Anahat07/CombatHateCrimesCanada.github.io",
      website: "https://anahat07.github.io/CombatHateCrimesCanada.github.io/"
    }
  },
  {
  title: "Hack the North Frontend Challenge",
  features: [
    "Developed an interactive event portal featuring an animated 3D chest landing scene that transitions into a responsive dashboard displaying Hack the North events.",
    "Structured the application using modular React components to separate the landing experience, dashboard, and authentication flow for better maintainability.",
    "Designed a polished and responsive UI using Tailwind CSS, including hover effects, subtle animations, and responsive layouts for different screen sizes.",
    "Implemented asynchronous event data fetching using Axios, with loading states to ensure a smooth and reliable user experience while data loads.",
    "Integrated Three.js and React Three Fiber to experiment with 3D elements in React, creating a floating diamond and animated visual effects to enhance the user interface.",
    "Added a demo login modal to simulate restricted content and demonstrate how authentication could be incorporated into a real production system."
  ],
  techStack: ["React", "Tailwind CSS", "Axios", "Three.js", "React Three Fiber", "Framer Motion"],
  images: [
    "/school_project_images/htnchallenge1.png",
    "/school_project_images/htnchallenge2.png",
    "/school_project_images/htnchallenge3.png",
    "/school_project_images/htnchallenge4.png",
    "/school_project_images/htnchallenge5.png",
    "/school_project_images/htnchallenge6.png",
    "/school_project_images/htnchallenge7.png"
  ],
  links: {
    github: "https://github.com/Anahat07/htn-frontend-challenge",
    demo: "https://htnchallenge-anahat.netlify.app/"
  }
}
];